import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=72c01946"
import script from "./ReceiptList.vue?vue&type=script&lang=js"
export * from "./ReceiptList.vue?vue&type=script&lang=js"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&id=72c01946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports